import debounce from 'lodash/debounce';
import Swiper from 'swiper/swiper-bundle.esm.browser.min.js';
import Slider from './slider';

class ArticleSidebar {
    constructor($container) {
        this.$container = $container;
        this.$sidebar = this.$container.querySelector('.article-sidebar');
        this.$slider = this.$container.querySelector('.article-gallery');

        if (!this.$sidebar || !this.$slider)
            return;

        this.init();
    }

    init() {
        this.build();
        this.initSliders();
        this.resize();
    }

    build() {
        this.$preview = this.$slider.cloneNode(true);

        this.$preview.classList.add('article-gallery-preview');
        this.$preview.setAttribute('aria-hidden', 'true');
        this.$sidebar.insertAdjacentElement('afterend', this.$preview);
        this.$slider.classList.add('article-gallery-main');

        objectFitPolyfill();

        window.addEventListener('resize', debounce(this.resize.bind(this), 300));
    }

    initSliders() {
        let slidesCount = this.$slider.querySelectorAll('.swiper-slide').length;

        let preview = new Swiper(this.$preview, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            navigation: true,
            allowTouchMove: false
        });

        let gallery = new Slider(this.$slider, {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: slidesCount > 1,
            navigation: true,
            watchOverflow: true,
            on: {
                slideChange: function() {
                    preview.slideToLoop(this.realIndex + 1, 200);
                },
                init: () => {
                    this.resize();
                }
            }
        });
    }

    resize() {
        let h = this.$sidebar.clientHeight;

        this.$container.style.height = `${h}px`;
        this.$container.nextElementSibling.style.marginTop = `-${h + 90}px`; // 90 == offset galerii
        this.$container.parentNode.style.minHeight = `${h + 90}px`;
    }
}

export default ArticleSidebar;
